import gql from 'graphql-tag';
export default gql `
  query SelfUserFlagQuery($displayFlag: UserFlagsDisplayFlag) {
    viewer {
      id
      selfUserFlagDetails(displayFlag: $displayFlag, platform: WEB) {
        title
        body
        action {
          text
          url
          urn
          trackingId
        }
      }
    }
  }
`;
//# sourceMappingURL=self-user-flag.query.js.map